import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { addUserAnswersApi } from "../../api";

interface AnswersState {
    answers: string[];
    status: "idle" | "loading" | "succeeded" | "failed";
    error: string | null;
}

const initialState: AnswersState = {
    answers: [],
    status: "idle",
    error: null
};

interface SubmitAnswersParams {
    userAnswersPayload: {
        answer: string;
        questionid: number;
        sectionid: number;
        questionnaireid: number;
        projectid: number;
    }[];
    idToken: string;
}
// AsyncThunk for calling addUserAnswersApi
export const submitAnswers = createAsyncThunk("answers/submitAnswers", async ({ userAnswersPayload, idToken }: SubmitAnswersParams, { rejectWithValue }) => {
    try {
        const response = await addUserAnswersApi({ answers: userAnswersPayload }, idToken);
        return response;
    } catch (error: any) {
        return rejectWithValue(error.message);
    }
});

const answersSlice = createSlice({
    name: "answers",
    initialState,
    reducers: {
        setAnswer: (state, action: PayloadAction<{ step: number; answer: string[] }>) => {
            state.answers = action.payload.answer;
        },
        resetAnswers: state => {
            state.answers = [];
        }
    },
    extraReducers: builder => {
        builder
            .addCase(submitAnswers.pending, state => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(submitAnswers.fulfilled, state => {
                state.status = "succeeded";
            })
            .addCase(submitAnswers.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload as string;
            });
    }
});

export const { setAnswer, resetAnswers } = answersSlice.actions;
export default answersSlice.reducer;
